module.exports = __webpack_public_path__ + "img/ronghao_portfolio6.1b676e74.jpg";